import { render, staticRenderFns } from "./ComercialStore.html?vue&type=template&id=f478894e&scoped=true&"
import script from "./ComercialStore.vue?vue&type=script&lang=js&"
export * from "./ComercialStore.vue?vue&type=script&lang=js&"
import style0 from "./ComercialStore.scss?vue&type=style&index=0&id=f478894e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f478894e",
  null
  
)

export default component.exports